var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,2.5c-5.5,0-10,4.5-10,10c0,1.6,0.4,3.1,1.1,4.5l-0.8,3.6c-0.2,0.8,0.3,1.5,1.1,1.7c0.2,0,0.4,0,0.6,0 L8,21.4c4.9,2.5,10.9,0.5,13.4-4.4S21.9,6.1,17,3.6C15.6,2.9,14.1,2.5,12.5,2.5z M12.5,20.9c-1.4,0-2.8-0.3-4-1 c-0.2-0.1-0.4-0.1-0.5-0.1l-3.6,0.8L5.2,17c0-0.2,0-0.4-0.1-0.5C2.9,12.4,4.4,7.3,8.5,5.1s9.2-0.7,11.4,3.4s0.7,9.2-3.4,11.4 C15.3,20.6,13.9,20.9,12.5,20.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.3,9.4H8.7c-0.4,0-0.8,0.3-0.8,0.8S8.2,11,8.7,11h7.7c0.4,0,0.8-0.3,0.8-0.8S16.8,9.4,16.3,9.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,14H8.7c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8h3.8c0.4,0,0.8-0.3,0.8-0.8 C13.3,14.4,12.9,14,12.5,14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.6502a860cd2f5a2c9876e156ae7a48bc.svg";
export { ForwardRef as ReactComponent };